import { render, staticRenderFns } from "./MemberAddUpdate.vue?vue&type=template&id=97f3b952&"
import script from "./MemberAddUpdate.vue?vue&type=script&lang=js&"
export * from "./MemberAddUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MemberAddUpdate.vue?vue&type=style&index=0&id=97f3b952&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports